enum CardProvider {
  Visa = 'Visa',
  Mastercard = 'Mastercard',
  Amex = 'Amex',
  JCB = 'JCB',
  Discover = 'Discover',
  UnionPay = 'UnionPay'
}

export const prettifyCardName = (cardName: string | undefined): CardProvider | undefined => {
  if (!cardName) return;

  const name = cardName.toLowerCase();

  if (name.startsWith('visa')) return CardProvider.Visa;

  if (name.startsWith('mc') || name.startsWith('mastercard')) return CardProvider.Mastercard;

  if (name.startsWith('amex') || name.startsWith('american express')) return CardProvider.Amex;

  if (name.startsWith('jcb')) return CardProvider.JCB;

  if (name.startsWith('discover')) return CardProvider.Discover;

  if (name.startsWith('union') || name.startsWith('cup')) return CardProvider.UnionPay;
};
